import * as api from '@/api/give-course/homeWork'
import * as TYPES from './type';

export default {
  //作业列表
  async getSKHomeWorkList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKHomeWorkList(paramets)
    commit(TYPES.SK_HOMEWORK_LIST, { result })
    cb && cb()
  },
  //作业完成学生
  async getSKHomeWorkStuCount({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKHomeWorkStuCount(paramets)
    commit(TYPES.SK_HOMEWORK_STU_COUNT, { result })
    cb && cb()
  },
  //作业未完成学生
  async getSKHomeWorkStuCountList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKHomeWorkStuCountList(paramets)
    commit(TYPES.SK_HOMEWORK_STU_LIST, { result })
    cb && cb()
  },
  //作业详情
  async getSKHomeWorkDetails({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKHomeWorkDetails(paramets)
    commit(TYPES.SK_HOMEWORK_DETAILS, { result })
    cb && cb()
  },
  //作业试题列表
  async getSKHomeWorkTestList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKHomeWorkTestList(paramets)
    commit(TYPES.SK_HOMEWORK_TEST_LIST, { result })
    cb && cb()
  },
  //作业学生完成情况
  async getSKHomeWorkStuMessage({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKHomeWorkStuMessage(paramets)
    commit(TYPES.SK_HOMEWORK_STU_MESSAGE, { result })
    cb && cb()
  },
  //作业编辑
  async putSKHomeWorkEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKHomeWorkEdit(paramets)
    commit(TYPES.SK_HOMEWORK_EDIT, { result })
    cb && cb()
  },
  //课后测验详情
  async getSKHomeTestDetail({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKHomeTestDetail(paramets)
    commit(TYPES.SK_HOMETEST_DETAIL, { result })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/homeWork/actions.js